import React, {useState, useEffect} from 'react';
import type {RuleConditionState} from '../../../modules/ruleengine/types';
import {DURATION_TRIGGER_MIN_VALUE, DURATION_TRIGGER_MAX_VALUE} from '../../../modules/ruleengine/config/consts';
type Props = {
	disabled: boolean;
	onChange: (arg0: Partial<RuleConditionState>) => void;
	value?: number;
};

const TriggerOptionalSettingsHoursInput = ({disabled, value, onChange}: Props) => {
	const [displayValue, setDisplayValue] = useState<number | null | undefined>(
		value ? Math.floor(value / 60) : undefined
	);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const {value} = event.target;
		onChange({
			duration: {
				durationInMin: value ? parseInt(value, 10) * 60 : undefined
			},
			counter: undefined
		});
	};

	useEffect(() => {
		if (displayValue && value === displayValue * 60) {
			return;
		}

		const minutesInHours = value ? Math.floor(value / 60) : value;
		setDisplayValue(minutesInHours);
	}, [displayValue, value]);
	return (
		<input
			data-testid="optional-setting-value"
			type="number"
			disabled={disabled}
			min={DURATION_TRIGGER_MIN_VALUE}
			max={Math.floor(DURATION_TRIGGER_MAX_VALUE / 60)}
			value={displayValue || ''}
			onChange={handleChange}
		/>
	);
};

export default TriggerOptionalSettingsHoursInput;
